/**
 * User roles enumeration
 */
export const Role = {
    User: 'USER',
    Admin: 'ADMIN',
    ProjectEditor: 'PROJECT_EDITOR',
}

/**
 * Application enumeration
 */
export const Application = {
    Project: 'Project',
    Marketing: 'Marketing',
}

/**
 * Transforms UserInfo from ReactAuthWrapper into User object with parsed permissions
 * @param {Object} userInfo - Raw user info from authentication
 * @param {string} userInfo.userId - User ID
 * @param {string} userInfo.userID - Alternative user ID field
 * @param {string} userInfo.firstName - User first name
 * @param {string} userInfo.lastName - User last name
 * @param {string} userInfo.email - User email
 * @param {Array} userInfo.permissions - User permissions array
 * @returns {Object} User object with parsed roles and applications
 */
export function transformUserInfo(userInfo) {
    const userId = (userInfo.userId ?? userInfo.userID)?.toString() ?? ''

    // Parse roles from permissions structure
    const rolesPermission = userInfo.permissions?.find(({ settingName }) => settingName === 'User permission')
    const roles = rolesPermission?.childSettings?.map((role) => Role[role.settingName])?.filter(Boolean) ?? []

    // Parse applications from permissions structure
    const applicationsPermission = userInfo.permissions?.find(({ settingName }) => settingName === 'Application')
    const applications =
        applicationsPermission?.childSettings?.map((app) => Application[app.settingName])?.filter(Boolean) ?? []

    return {
        ...userInfo,
        id: userId,
        roles,
        applications,
    }
}
